
import { Vue, Component } from 'vue-property-decorator'
import { checkUserBindMobile } from '@/api/customerManage'
import { toBindMobile } from '@/utils/h5ToApp'

@Component({
  name: 'OrderFinance'
})
export default class OrderFinance extends Vue {
  toApplyQuota (type: number) {
    // if (!this.$action('applyQuota' + type)) {
    //   return false
    // }
    if (type === 1) {
      //    判断是否绑定手机号
      checkUserBindMobile().then((res) => {
        if (res.code === '000000') {
          this.jumpToApplyQuota(type)
        } else if (res.code === '000002') {
          // 前端跳绑定手机流程
          const data = {
            path: 'applyQuota', // 客户选择页面路由名称
            applyType: 1 // 选择客户类型
          }
          toBindMobile(data)
        }
      })
    } else {
      this.jumpToApplyQuota(type)
    }
  }

  /**
   * 跳转到客户选择页面
   * @param type 1.未出额（去出额）2.已出额（去借款）3.已放款（去还款）
   */
  jumpToApplyQuota (type: number) {
    this.$router.push({
      path: '/applyQuota',
      query: {
        applyType: type + ''
      }
    })
  }
}
